import { SET_CURRENT_CUSTOMER } from "./actionTypes";

export const setRecentlyViewedCustomer = (payload) => ({ type: SET_CURRENT_CUSTOMER, payload });
